export default "__VITE_ASSET__C8hl7XBT__"